(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfection-campaign-video"] && !Shopify.designMode) return;
  try {
    
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.perfection-campaign__video[autoplay]').forEach((video) => {
    if (reducedMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }

    video.muted = true;

    const playImmediately = () => video.play().catch(() => {});

    if (video.readyState >= 2) {
      playImmediately();
    } else {
      video.addEventListener('canplay', playImmediately, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfection-product-motion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = document.querySelectorAll('[data-perfection-motion-card]');

    const loadVideo = (video) => {
      if (video.dataset.loaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      video.dataset.loaded = 'true';
      video.load();
    };

    const setState = (card, video, button) => {
      const isPlaying = !video.paused;
      card.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-label', isPlaying ? 'Video pausieren' : 'Video abspielen');
      const label = button.querySelector('span');
      if (label) label.textContent = isPlaying ? 'Pause' : 'Play';
    };

    cards.forEach((card) => {
      const video = card.querySelector('[data-perfection-motion-video]');
      const button = card.querySelector('[data-perfection-motion-toggle]');
      if (!video || !button) return;

      const toggleVideo = () => {
        loadVideo(video);

        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      button.addEventListener('click', toggleVideo);
      video.addEventListener('click', toggleVideo);
      video.addEventListener('play', () => setState(card, video, button));
      video.addEventListener('pause', () => setState(card, video, button));
      video.addEventListener('ended', () => setState(card, video, button));
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, activeObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const video = entry.target.querySelector('[data-perfection-motion-video]');
            if (video) loadVideo(video);
            activeObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '160px 0px', threshold: 0.01 }
      );

      cards.forEach((card) => observer.observe(card));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
